import React from 'react';
import styles from '../../styles/cr.module.scss';
import { CrBadges } from './CrBadges';
import { CrEntityCompleteIcon } from './CrEntityCompleteIcon';
import { CrLastEdit } from './CrLastEdit';
import { CrReviewListHistory } from './CrReviewListHistory';

export const ReviewListProgressUpdate = (
    { entityName, progressUpdate, updateAuthor, updateDate, toBeClosed, customFields, previousUpdate, lead, additionalItemsString }
        : { entityName: string, progressUpdate: string, updateAuthor: string, updateDate: Date, toBeClosed: boolean, customFields?: string[], previousUpdate?: string, lead?: string, additionalItemsString?: string }
): React.ReactElement =>
    <div>
        {toBeClosed &&
            <CrEntityCompleteIcon />
        }
        <div className={styles.fontWeightSemibold}>
            <span style={{ fontSize: '16px' }}>{entityName} </span>
            {customFields &&
                <CrBadges badges={customFields && customFields.map(a => ({ text: a, description: `CustomField: ${a}`, badgeClass: styles.badgeSecondary }))} />
            }
        </div>
        <div style={{ fontSize: '15px' }}>{progressUpdate}</div>
        <CrLastEdit lead={lead} author={updateAuthor} editDate={updateDate} additionalItemsString={additionalItemsString} />
        {previousUpdate &&
            <CrReviewListHistory value={previousUpdate} />
        }
    </div>;
